/* Así funciona · Tapete de Piedra Diatomita Absorbente (1484433), gris
   Escena: el baño del producto (el tapete gris real a la salida de la ducha). La clienta sale de la ducha o toca el
   tapete para pisarlo: quedan HUELLAS MOJADAS REALES (las de la foto del fabricante "Dries in seconds": paneles de 0 s,
   5 s y 10 s del mismo tapete; la huella = 1 - panel mojado / panel seco, o sea solo el agua) acostadas en el plano real
   del tapete (homografía de sus 4 esquinas, con la escala real: tapete de 60 x 39 cm, pie de unos 24 cm). La piedra se
   oscurece donde está mojada y se seca en segundos como en la foto: de la huella de 0 s a la de 5 s y a los 10 s ya no
   queda nada (primero lo delgado, al final el talón y la planta). El tiempo es el real de la foto (no va acelerado).
   Ficha: absorbe y se seca rápido; para baño, cocina o matas; se limpia con paño húmedo.
   Piezas: tiendas/nayhogar/funciona/tapete-de-piedra-diatomita-absorbente/hacer.py */
NHF.escena('tapete-de-piedra-diatomita-absorbente', function (E) {
  const D = /*DATOS*/{"bano":"fn-tapete-de-piedra-diatomita-absorbente-bano.webp","bano_caja":[0,300,1600,1300],"quad":[[262.4,1122.5],[1007.6,1486.2],[1333.3,1114.8],[663.8,931.5]],"poligono":[[293,1125],[295,1136],[301,1147],[315,1150],[321,1153],[322,1156],[330,1156],[331,1160],[338,1160],[340,1166],[345,1169],[357,1169],[359,1172],[364,1172],[365,1176],[373,1176],[379,1179],[381,1185],[393,1186],[395,1191],[410,1194],[415,1200],[432,1204],[435,1208],[442,1209],[449,1215],[454,1215],[460,1220],[466,1220],[467,1224],[482,1228],[488,1233],[491,1240],[506,1240],[523,1250],[527,1255],[538,1256],[556,1265],[561,1272],[578,1275],[580,1279],[592,1284],[599,1292],[606,1292],[611,1297],[619,1297],[627,1305],[643,1308],[644,1312],[652,1313],[657,1319],[668,1320],[672,1327],[682,1329],[683,1332],[691,1332],[692,1336],[702,1337],[709,1343],[715,1344],[719,1351],[723,1353],[738,1354],[742,1357],[742,1360],[753,1362],[755,1369],[765,1369],[775,1378],[786,1378],[791,1388],[810,1388],[812,1392],[821,1396],[821,1400],[828,1400],[835,1407],[850,1408],[851,1414],[866,1420],[869,1424],[877,1424],[885,1432],[893,1432],[895,1435],[904,1436],[915,1447],[926,1449],[927,1452],[940,1452],[941,1455],[946,1455],[950,1462],[982,1469],[1014,1467],[1035,1455],[1040,1455],[1043,1450],[1048,1448],[1056,1439],[1060,1427],[1118,1363],[1119,1359],[1125,1353],[1132,1353],[1133,1344],[1143,1343],[1143,1332],[1151,1321],[1187,1283],[1187,1280],[1195,1276],[1195,1272],[1198,1271],[1200,1266],[1203,1266],[1205,1259],[1224,1238],[1227,1238],[1228,1232],[1238,1224],[1238,1221],[1247,1211],[1250,1211],[1250,1207],[1254,1202],[1260,1200],[1260,1195],[1271,1190],[1284,1171],[1288,1169],[1303,1150],[1305,1138],[1303,1127],[1293,1115],[1259,1101],[707,947],[673,940],[659,940],[638,947],[634,953],[622,955],[439,1046],[411,1057],[338,1093],[335,1097],[330,1097],[297,1115]],"caja_tapete":[284,931,1031,550],"huellas":"fn-tapete-de-piedra-diatomita-absorbente-huellas.webp","hoja":{"w":380,"h":364,"n":14,"tiempos":[0,0.6,1.3,2.1,3.0,4.0,5.0,5.8,6.6,7.4,8.2,9.0,9.6,10.0]},"pies":{"izq":[0,0,190,364],"der":[190,0,190,364]},"cm_px":0.0785,"cm":[60,39]}/*FIN*/;
  const S = E.lienzo({ w: 1600, h: 1600, vista: [100, 540, 1440, 990], vistaMovil: [230, 640, 1140, 1000] });
  E.titulo('Pisa mojado, [queda seco].', 'Sal de la ducha y pisa el tapete: la piedra se toma el agua y en segundos tus huellas desaparecen.');
  E.conSonido();
  S.cargando(true);
  S.img(D.bano, D.bano_caja, { z: 1, alt: 'Tapete de piedra gris a la salida de la ducha' });
  const CT = D.caja_tapete;
  const lz = S.canvas(CT, { z: 3, res: Math.min(1, (window.devicePixelRatio || 1) * 0.6) });
  let hoja = null;
  E.cargar([D.bano, D.huellas]).then(r => { hoja = r[1]; S.cargando(false); });

  /* ---------- plano real del tapete: u = largo (60 cm), v = ancho (39 cm) ---------- */
  const Hm = E.homografia([[0, 0], [1, 0], [1, 1], [0, 1]], D.quad);
  const aFoto = (u, v) => { const w = Hm[6] * u + Hm[7] * v + 1; return [(Hm[0] * u + Hm[1] * v + Hm[2]) / w, (Hm[3] * u + Hm[4] * v + Hm[5]) / w]; };
  const Hi = E.homografia(D.quad, [[0, 0], [1, 0], [1, 1], [0, 1]]);
  const aTapete = (x, y) => { const w = Hi[6] * x + Hi[7] * y + 1; return [(Hi[0] * x + Hi[1] * y + Hi[2]) / w, (Hi[3] * x + Hi[4] * y + Hi[5]) / w]; };
  const CM = D.cm, HJ = D.hoja;

  /* ---------- huellas ---------- */
  const huellas = [];
  let primera = null, ultimoPaso = 0, listoYa = false;
  // u, v = centro de la huella en el tapete; pie = 'par' | 'izq' | 'der'; g = giro (grados) en el plano del tapete
  function pisar(u, v, pie, g) {
    huellas.push({ u, v, pie, g: g || 0, t0: performance.now() });
    if (huellas.length > 10) huellas.shift();
    ultimoPaso = performance.now();
    if (!primera) primera = huellas[huellas.length - 1];
    E.sonido.ruido(140, 0.018, 520); E.vibrar(8);
    if (!listoYa) E.paso(1);
    S.pista('Mira cómo la piedra se toma el agua', 'toca');
  }
  function dibujar(ahora) {
    lz.limpiar();
    if (!hoja || !huellas.length) return;
    const ctx = lz.ctx, r = lz.res, cmpx = D.cm_px;
    ctx.save();
    ctx.beginPath(); D.poligono.forEach((p, i) => i ? ctx.lineTo(p[0], p[1]) : ctx.moveTo(p[0], p[1])); ctx.closePath(); ctx.clip();
    huellas.forEach(h => {
      const t = (ahora - h.t0) / 1000; // segundos desde que pisó
      const T = HJ.tiempos, fin = T[T.length - 1];
      if (t >= fin) return;
      let i = 0; while (i < T.length - 2 && t >= T[i + 1]) i++;
      const fr = E.clamp((t - T[i]) / (T[i + 1] - T[i]), 0, 1);
      // al pisar, el agua se reparte en un instante
      const ap = E.clamp(t / 0.16, 0, 1), esc = 0.97 + 0.03 * ap;
      const rect = h.pie === 'par' ? [0, 0, HJ.w, HJ.h] : D.pies[h.pie];
      // mapa afín local: px de la huella -> cm en el tapete (giro g) -> (u, v) -> px de la foto (jacobiano de la homografía)
      const P = aFoto(h.u, h.v), e = 0.002;
      const pu1 = aFoto(h.u + e, h.v), pu0 = aFoto(h.u - e, h.v), pv1 = aFoto(h.u, h.v + e), pv0 = aFoto(h.u, h.v - e);
      const Ju = [(pu1[0] - pu0[0]) / (2 * e), (pu1[1] - pu0[1]) / (2 * e)], Jv = [(pv1[0] - pv0[0]) / (2 * e), (pv1[1] - pv0[1]) / (2 * e)];
      const th = h.g * Math.PI / 180, cs = Math.cos(th), sn = Math.sin(th);
      // los dedos (arriba en la huella) van hacia +u; la izquierda de la huella hacia +v
      const r1 = [sn, -cs], r2 = [-cs, -sn];
      const ax = [Ju[0] * r1[0] / CM[0] + Jv[0] * r1[1] / CM[1], Ju[1] * r1[0] / CM[0] + Jv[1] * r1[1] / CM[1]];
      const ay = [Ju[0] * r2[0] / CM[0] + Jv[0] * r2[1] / CM[1], Ju[1] * r2[0] / CM[0] + Jv[1] * r2[1] / CM[1]];
      const k = cmpx * esc;
      ctx.setTransform(r * ax[0] * k, r * ax[1] * k, r * ay[0] * k, r * ay[1] * k, r * (P[0] - CT[0]), r * (P[1] - CT[1]));
      const cuadro = (n, a) => { if (a <= 0.003) return; ctx.globalAlpha = a * ap; ctx.drawImage(hoja, n * HJ.w + rect[0], rect[1], rect[2], rect[3], -rect[2] / 2, -rect[3] / 2, rect[2], rect[3]); };
      cuadro(i, 1 - fr); cuadro(i + 1, fr);
    });
    ctx.restore();
    lz.reset();
  }

  /* ---------- tocar el tapete = pisarlo ---------- */
  const zona = S.toque(CT, { etiqueta: 'Pisa el tapete', alTocar: e => {
    const p = S.punto(e);
    const [u, v] = aTapete(p.x, p.y);
    if (u < 0.02 || u > 0.98 || v < 0.02 || v > 0.98) return;
    // de pie con los dos pies (el par real), sin salirse del tapete
    pisar(E.clamp(u, 0.24, 0.76), E.clamp(v, 0.36, 0.64), 'par', (Math.random() - 0.5) * 16);
  } });
  zona.style.cursor = 'pointer';

  /* ---------- "Sal de la ducha": un paso, otro y quedarse de pie ---------- */
  let caminando = false;
  async function salir() {
    if (caminando) return; caminando = true;
    pisar(0.27, 0.37, 'der', -6); await E.esperar(520);
    pisar(0.47, 0.63, 'izq', 5); await E.esperar(560);
    pisar(0.68, 0.5, 'par', 0);
    bSalir.texto('Sal otra vez');
    caminando = false;
  }

  /* ---------- panel ---------- */
  E.pasos(['Sal de la ducha y pisa el tapete', 'Mira cómo la piedra se toma el agua', 'Pisa otra vez donde quieras']);
  E.paso(0);
  const bSalir = E.boton('Sal de la ducha', () => salir(), { icono: 'mano', primario: true });
  const lect = E.lectura({ etiqueta: 'La piedra' }); lect.poner('Seca');
  lect.querySelector('.nhf-lectura__v').style.fontSize = 'clamp(30px,3.4vw,44px)';
  E.nota('Absorbe el agua y se seca en segundos. Sirve también en la cocina o bajo las matas, y se limpia con un paño húmedo.');
  S.pista('Toca el tapete para pisarlo', 'toca');

  let estado = '';
  E.bucle(() => {
    const ahora = performance.now();
    dibujar(ahora);
    const fin = HJ.tiempos[HJ.tiempos.length - 1] * 1000;
    const vivas = huellas.filter(h => ahora - h.t0 < fin);
    let txt, peq = '';
    if (!vivas.length) txt = huellas.length ? 'Seca otra vez' : 'Seca';
    else {
      const t = (ahora - ultimoPaso) / 1000;
      txt = t < 1.2 ? 'Mojada' : 'Secándose';
      peq = Math.floor(t) + ' s';
    }
    if (txt + peq !== estado) { estado = txt + peq; lect.poner(txt, peq); }
    if (primera && !listoYa && ahora - primera.t0 > fin && !vivas.length) {
      listoYa = true; E.paso(3);
      S.pista('Pisa otra vez donde quieras', 'toca');
      E.listo('Pisas mojado, la piedra se toma el agua y en segundos queda seca otra vez.', reiniciar);
    }
  });
  function reiniciar() {
    huellas.length = 0; primera = null; listoYa = false; E.noListo();
    bSalir.texto('Sal de la ducha'); E.paso(0); lect.poner('Seca'); estado = '';
    S.pista('Toca el tapete para pisarlo', 'toca');
  }
});
